// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseStatusNotification.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * License Status Notification component
 */
!(function () {

  var observer = require('mobx-react').observer;
  var connect = require('share/enhancers/Izenda.Connect');
  var React = require('react');
  var EmailConstants  = require('logic/data/Izenda.EmailConstants');
  var LicenseInfoConstants = require('logic/data/Izenda.LicenseInfoConstants');
  var AppStore = require('logic/Izenda.AppStore');
  var PERMISSION_KEY = require('logic/data/Izenda.AuthorizationConstants').PERMISSION_KEY;

  var LicenseStatusNotification = React.createClass({
    sendPurchaseEmail: function(){
      window.location = EmailConstants.EMAIL.sale;
    },

    render: function () {
      var props = this.props;
      var licenseInfo = AppStore.licenseInfoStore.licenseInfo;
      var localization = props.localization;
      var hasSeeSystemMessagePrivilege = props.authorization.checkPrivileges([PERMISSION_KEY.SystemwideCanSeeSystemMessagesValue]);

      if (!licenseInfo.meetExprireWarningPeriod || !hasSeeSystemMessagePrivilege) {
        return null;
      }

      var message = this.buildMessage(licenseInfo.numberOfDayToExpire);

      return (
        <div>
          <span className="icon-attention">{message}</span>
          <button className="btn btn-primary pull-right" onClick={this.sendPurchaseEmail}>
            {licenseInfo.trialLicense
              ? localization.getText("LICENSE_CHECKER_LABEL_READY_PURCHASE")
              : localization.getText("LICENSE_CHECKER_LABEL_RENEW_LICENSE")
            }
          </button>
        </div>
      );
    },

    /**
     * Build notify message.
     * @param {Number} numberOfDayToExpire
     */
    buildMessage: function (numberOfDayToExpire) {
      if (numberOfDayToExpire < 0) {
        return String.format(LicenseInfoConstants.MESSAGE.MG05a, Math.abs(numberOfDayToExpire));
      } else if (numberOfDayToExpire === 0) {
        return LicenseInfoConstants.MESSAGE.MG05b;
      }
      return String.format(LicenseInfoConstants.MESSAGE.MG05, numberOfDayToExpire);
    }
  });

  module.exports = connect()(LicenseStatusNotification);
} ());



// WEBPACK FOOTER //
// ./ui/modules/Settings/LicenseChecker/Izenda.LicenseStatusNotification.jsx